import React from 'react';
import { Mail, Phone, MapPin, Calendar } from 'lucide-react';
import { Button } from './ui/button';

const WHATSAPP_URL = 'https://wa.me/56961964694?text=Hola%20Hotel%20Montecarlo,%20quisiera%20consultar%20disponibilidad%20para%20una%20reserva';

const Contact = () => {
  const handleBookingClick = () => {
    window.open(WHATSAPP_URL, '_blank');
  };

  return (
    <section id="contact" className="py-16 bg-gray-50"> {/* ← AGREGADO id="contact" */}
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-gray-800">
          Contacto e Información
        </h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Estamos aquí para atenderte. Contáctanos por cualquiera de estos medios
        </p>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Información de Contacto */}
            <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-2xl p-8 text-white shadow-xl">
              <h3 className="text-2xl font-bold mb-6">Información de Contacto</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6" />
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Dirección</h4>
                    <p className="text-white/90">
                      Carvallo 627<br />Caldera, Atacama, Chile
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6" />
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Teléfonos</h4>
                    <p className="text-white/90">
                      <a href="tel:+56522315388" className="hover:text-amber-400 transition-colors block whitespace-nowrap">
                        +56 52 2315388
                      </a>
                      <a href="tel:+56961964694" className="hover:text-amber-400 transition-colors block whitespace-nowrap">
                        +56 9 61964694
                      </a>
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6" />
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Email</h4>
                    {/* ORDEN SOLICITADO: 1. Reserva, 2. Gmail */}
                    <a
                      href="mailto:reserva@hotel-montecarlo.cl"
                      className="text-white/90 hover:text-amber-400 transition-colors block whitespace-nowrap"
                    >
                      reserva@hotel-montecarlo.cl
                    </a>
                    <a
                      href="mailto:hotel.montecarloatacama@gmail.com"
                      className="text-white/90 hover:text-amber-400 transition-colors block whitespace-nowrap"
                    >
                      hotel.montecarloatacama@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Horarios y Reservas */}
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-8 shadow-md">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Horario de Atención</h3>
                <p className="text-gray-600 mb-2">Recepción 24 horas</p>
                <p className="text-gray-600">Desayuno Continental: 08:00 - 10:00 am hrs</p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-md">
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Calendar className="w-6 h-6 text-amber-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Reservas Online</h3>
                    <p className="text-gray-600">
                      Realiza tu reserva de forma rápida y segura a través de nuestro sistema de reservas en línea
                    </p>
                  </div>
                </div>
                <Button
                  onClick={handleBookingClick}
                  className="w-full bg-amber-600 hover:bg-amber-700 text-white py-6 text-lg font-semibold shadow-lg"
                >
                  Reservar Ahora
                </Button>
              </div>
            </div>
          </div>

          {/* Ubicación */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="p-6 border-b">
              <h3 className="text-2xl font-bold text-gray-900">Nuestra Ubicación</h3>
              <p className="text-gray-600 mt-2">En el corazón de Caldera, cerca de todo</p>
            </div>
            <div className="h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3552.776084363194!2d-70.82574368453812!3d-27.068814983060566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96bd69e7f2ac2299%3A0x9c1ffe5369c86d7e!2sHotel+Montecarlo!5e0!3m2!1ses!2scl!4v1564009176845!5m2!1ses!2scl"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación Hotel Montecarlo"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;